import StateOptions from './options.state';
import DescriptionOptions from './options.descriptions';
import BadgeState from './badge.state';

export const StateOptionsByType = (props) => StateOptions(props);
export const DescriptionOptionsByType = (props) => DescriptionOptions(props);
export const BadgeStates = (props) => BadgeState(props);
